export const movies = [
  {
    id: "mv-001",
    title: "星海回声",
    type: "movie" as const,
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    year: 2024,
    rating: 8.7,
    duration: "142分钟",
    director: "顾长风",
    cast: ["林叙白", "苏晚舟", "陈望舒", "何汀"],
    tags: ["太空", "科幻", "视听盛宴"],
    synopsis:
      "一艘失联十二年的深空探测船突然传回信号。宇航员江彻临危受命，独自踏上寻找真相的旅程。当他在星海尽头听见那声熟悉的呼唤，人类对宇宙与孤独的理解被彻底改写。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%2C%20lone%20astronaut%20drifting%20before%20a%20glowing%20golden%20nebula%2C%20deep%20teal%20cosmos%2C%20dramatic%20rim%20light%2C%20epic%20sci-fi%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-001-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20sci-fi%20still%2C%20astronaut%20silhouette%20above%20a%20glowing%20blue%20planet%20amid%20endless%20stars%2C%20epic%20scale%2C%20teal%20and%20amber%20lighting%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jg-mv-001-b&orientation=landscape",
    heat: 98,
  },
  {
    id: "mv-002",
    title: "逆风追缉",
    type: "movie" as const,
    genres: ["动作", "悬疑"],
    region: "中国香港",
    year: 2024,
    rating: 8.2,
    duration: "118分钟",
    director: "麦志雄",
    cast: ["郑嘉树", "袁靖", "罗子悦"],
    tags: ["警匪", "追凶", "高能"],
    synopsis:
      "一场台风夜里，重案组探员程野追查一桩离奇连环案。线索却一步步指向他最信任的搭档。狂风暴雨中，正义与情义的界线开始模糊。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%2C%20determined%20detective%20in%20rain-soaked%20neon%20alley%20at%20night%2C%20motion%20blur%2C%20tense%20mystery%20mood%2C%20high%20contrast%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-002-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20action%20still%2C%20rain-soaked%20city%20street%20at%20night%20with%20car%20headlights%20and%20silhouetted%20figure%20running%2C%20neon%20reflections%2C%20gritty%20thriller%20mood%2C%20no%20text&width=1600&height=900&seq=jg-mv-002-b&orientation=landscape",
    heat: 91,
  },
  {
    id: "mv-003",
    title: "山楂树之约",
    type: "movie" as const,
    genres: ["爱情", "剧情"],
    region: "中国大陆",
    year: 2023,
    rating: 8.9,
    duration: "126分钟",
    director: "沈知秋",
    cast: ["温言", "江辞", "陆轻禾"],
    tags: ["青春", "年代", "疗愈"],
    synopsis:
      "上世纪的小城里，两个年轻人在一棵山楂树下许下约定。三十年后，一封信重新打开尘封的记忆。这是一段关于等待、错过与释怀的温柔故事。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%2C%20young%20couple%20under%20a%20blooming%20hawthorn%20tree%20in%20golden%20afternoon%20light%2C%20soft%20warm%20tones%2C%20tender%20nostalgic%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-003-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20romance%20still%2C%20sunlit%20countryside%20hills%20with%20blooming%20white%20trees%20and%20two%20distant%20figures%2C%20warm%20golden%20hour%20glow%2C%20soft%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jg-mv-003-b&orientation=landscape",
    heat: 88,
  },
  {
    id: "mv-004",
    title: "第七夜班车",
    type: "movie" as const,
    genres: ["悬疑"],
    region: "韩国",
    year: 2024,
    rating: 7.8,
    duration: "104分钟",
    director: "金泰浩",
    cast: ["朴敏俊", "崔妍", "李承贤"],
    tags: ["惊悚", "烧脑", "密室"],
    synopsis:
      "每天凌晨两点，一班没有终点站的夜班车准时出现。乘客们发现，他们必须在第七夜之前找到下车的方法，否则将永远留在车上。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20poster%2C%20mysterious%20empty%20night%20bus%20interior%20with%20flickering%20cold%20light%2C%20dark%20moody%20atmosphere%2C%20suspenseful%20composition%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-004-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20thriller%20still%2C%20empty%20bus%20driving%20through%20a%20foggy%20city%20road%20at%20midnight%2C%20cold%20blue%20headlights%2C%20eerie%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jg-mv-004-b&orientation=landscape",
    heat: 84,
  },
  {
    id: "mv-005",
    title: "云端咖啡屋",
    type: "movie" as const,
    genres: ["爱情", "喜剧"],
    region: "日本",
    year: 2023,
    rating: 8.4,
    duration: "112分钟",
    director: "佐藤由纪",
    cast: ["小林遥", "木村圭", "森川绫"],
    tags: ["治愈", "轻喜剧", "美食"],
    synopsis:
      "失意的甜点师与人气美食博主因一场乌龙在屋顶咖啡屋相遇。两人从互相嫌弃到携手经营，一杯咖啡的香气里，藏着重新出发的勇气。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20comedy%20poster%2C%20cozy%20sunlit%20cafe%20with%20warm%20wooden%20interior%20and%20hanging%20plants%2C%20cheerful%20soft%20light%2C%20inviting%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-005-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20charming%20rooftop%20cafe%20above%20soft%20clouds%20at%20golden%20hour%2C%20warm%20inviting%20light%2C%20delicate%20pastel%20tones%2C%20gentle%20romantic%20mood%2C%20no%20text&width=1600&height=900&seq=jg-mv-005-b&orientation=landscape",
    heat: 80,
  },
  {
    id: "mv-006",
    title: "钢铁黎明",
    type: "movie" as const,
    genres: ["动作", "科幻"],
    region: "美国",
    year: 2024,
    rating: 8,
    duration: "148分钟",
    director: "Marcus Vale",
    cast: ["Ethan Cole", "Nora Reid", "David Kell"],
    tags: ["机甲", "末世", "爽片"],
    synopsis:
      "当钢铁巨兽从地底苏醒，人类最后的防线只剩下三台退役机甲。老驾驶员带着一群新兵，在黎明前的废墟上，打响了决定命运的最后一战。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20action%20poster%2C%20armored%20soldier%20standing%20before%20a%20colossal%20mecha%20under%20stormy%20sky%2C%20steel%20and%20fire%20tones%2C%20epic%20scale%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-006-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20sci-fi%20still%2C%20futuristic%20city%20skyline%20under%20dawn%20light%20with%20giant%20mecha%20silhouette%2C%20smoke%20and%20orange%20glow%2C%20epic%20scale%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=jg-mv-006-b&orientation=landscape",
    heat: 95,
  },
  {
    id: "mv-007",
    title: "小城奇遇记",
    type: "movie" as const,
    genres: ["动画", "喜剧"],
    region: "中国大陆",
    year: 2023,
    rating: 9.1,
    duration: "98分钟",
    director: "白一鸣",
    cast: ["配音：夏川", "配音：麦小满", "配音：赵多多"],
    tags: ["合家欢", "成长", "暖心"],
    synopsis:
      "小镇女孩朵朵捡到一个会说方言的机器人，两人为找回它失落的记忆踏上冒险。一路上奇妙又爆笑的遭遇，让朵朵学会了勇敢与珍惜。",
    cover: "https://readdy.ai/api/search-image?query=Charming%20animated%20movie%20poster%2C%20curious%20child%20and%20small%20robot%20friend%20in%20a%20colorful%20small%20town%2C%20warm%20playful%20illustration%2C%20bright%20cheerful%20palette%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-007-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20animated%20still%2C%20whimsical%20small%20town%20street%20with%20colorful%20rooftops%20and%20a%20tiny%20robot%2C%20sunny%20cheerful%20illustration%2C%20warm%20playful%20palette%2C%20no%20text&width=1600&height=900&seq=jg-mv-007-b&orientation=landscape",
    heat: 93,
  },
  {
    id: "mv-008",
    title: "深海信标",
    type: "movie" as const,
    genres: ["科幻", "冒险"],
    region: "英国",
    year: 2022,
    rating: 7.6,
    duration: "130分钟",
    director: "Oliver Grant",
    cast: ["Sophie Lane", "James Harrow"],
    tags: ["深海", "探险", "悬念"],
    synopsis:
      "一支深海科考队在无人区发现一座会发光的古老灯塔。随着下潜深度增加，队员们发现信标似乎在回应某种沉睡已久的呼唤。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20poster%2C%20deep%20sea%20diver%20before%20a%20glowing%20ancient%20lighthouse%20underwater%2C%20teal%20bioluminescence%2C%20mysterious%20grand%20scale%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-008-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20underwater%20still%2C%20deep%20blue%20ocean%20with%20a%20glowing%20beacon%20and%20diver%20silhouette%20among%20luminous%20creatures%2C%20mysterious%20grand%20scale%2C%20no%20text&width=1600&height=900&seq=jg-mv-008-b&orientation=landscape",
    heat: 72,
  },
  {
    id: "mv-009",
    title: "长夜将尽",
    type: "movie" as const,
    genres: ["剧情", "悬疑"],
    region: "法国",
    year: 2021,
    rating: 8.3,
    duration: "121分钟",
    director: "Claire Dubois",
    cast: ["Nicolas Bernard", "Amélie Roux"],
    tags: ["文艺", "人性", "口碑"],
    synopsis:
      "一名老警探退休前的最后一宗案子，牵出小城几十年的秘密。在漫长的雨夜里，他必须决定：是揭开真相，还是让所有人都安然睡去。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%2C%20lone%20figure%20at%20a%20dim%20window%20overlooking%20a%20foggy%20old%20European%20city%20at%20dusk%2C%20moody%20amber%20and%20gray%20tones%2C%20quiet%20melancholy%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-009-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20drama%20still%2C%20rain-washed%20European%20street%20at%20dusk%20with%20warm%20street%20lamps%20and%20long%20shadows%2C%20moody%20gray%20and%20amber%20tones%2C%20no%20text&width=1600&height=900&seq=jg-mv-009-b&orientation=landscape",
    heat: 68,
  },
  {
    id: "mv-010",
    title: "山那边是海",
    type: "movie" as const,
    genres: ["剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.6,
    duration: "116分钟",
    director: "秦岭",
    cast: ["周正国", "李一诺", "吴知远"],
    tags: ["亲情", "现实主义", "催泪"],
    synopsis:
      "山村教师带着一群孩子翻山越岭，只为让他们第一次看见大海。这段朴素而漫长的旅程，改变了孩子们，也治愈了老师自己。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%2C%20parent%20and%20child%20on%20a%20green%20mountain%20ridge%20looking%20toward%20a%20distant%20sea%2C%20warm%20sunset%20light%2C%20moving%20hopeful%20mood%2C%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=jg-mv-010-p&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%2C%20misty%20mountain%20ridge%20at%20sunrise%20with%20a%20distant%20glittering%20sea%20and%20two%20small%20figures%2C%20warm%20hopeful%20light%2C%20no%20text&width=1600&height=900&seq=jg-mv-010-b&orientation=landscape",
    heat: 86,
  },
];